<template>
    <div>
        <div v-for="(item,index) in list" :key="index"  class="matchitem" @click="bindClick(item)">
            <div :style="{backgroundImage:'url('+item.imgurl+')'}" class="img">
            </div>
            <div class="title">
                <div>{{item.title}}</div>
                <div>报名时间:{{item.reg_start_time*1000|moment("MM-DD h:mm")}} - {{item.reg_end_time*1000|moment("MM-DD h:mm")}}</div>
                <div>举办时间:{{item.start_time*1000|moment("YYYY-MM-DD")}}</div>
            </div>
            <div class="state" :style="{color:filteritem(item).fontcolor,backgroundColor:filteritem(item).bgcolor}">
                {{filteritem(item).state}}
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    import { fromatMatchTime } from '@/libs/utils'
    import { Dialog } from 'vant'
    export default {
        name: 'MatchList',
        filters:{

        },
        props: {
            list: Array
        },
        methods:{
            bindClick:function(e){
                 // console.log(e)
                 var matchid = ''
                if(e.id){
                    matchid = e.id
                }else{
                    matchid = e.matchid
                }
                this.$router.push({name:'mdetail',params:{matchid:matchid}})
                // this.$router.push({name:'mdetail',params:{matchid:e}})
                // 
            },
            state:function(e){
               return e.title;
            },
            filteritem:function(e){
              return  fromatMatchTime(e)
            }
        },
        computed:{

        }
    }
</script>
<style scoped lang="less">
    @import 'index';
</style>
